import { useState } from "react";

import { useTranslation } from "react-i18next";

declare global {
  interface Window {
    $crisp: any;
  }
}

export default function useCrisp() {
  const [isCrispOpen, setIsCrispOpen] = useState(false);
  const { t } = useTranslation();

  return {
    trigger: () => {
      const { $crisp } = window;
      if ($crisp) {
        $crisp.push(["do", "chat:toggle"]);
        setIsCrispOpen(!isCrispOpen);
      } else {
        alert(t("Components.sidebar.crisp-unavailable"));
      }
    },
    isCrispOpen,
  };
}
